let svg_imgs = document.querySelectorAll('.style-svg');

let svg_img_count = 0;

let svg_img_observer = new MutationObserver(
    function (mutations, observer) {
        for (const mutation of mutations) {
            if (mutation.type === 'childList') {
                window.dispatchEvent(new Event('svg-loaded'));
                svg_img_count++;
                if (svg_img_count == svg_imgs.length) {
                    svg_img_observer.disconnect();
                }
            }
        }
    }
);

svg_imgs.forEach(svg_img => {
    svg_img_observer.observe(svg_img.parentElement, { childList: true });
});